<template>
  <div class="match-overlay-root">
    <div v-if="loading" class="match-overlay-status">Ielādē...</div>
    <div v-else-if="loadError" class="match-overlay-status">Neizdevās ielādēt spēles datus.</div>
    <div v-else-if="notFound" class="match-overlay-status">Spēle nav atrasta.</div>
    <div v-else class="match-overlay-inner">
      <div class="match-panel">
        <table class="match-table">
          <thead>
            <tr>
              <th>Team</th>
              <th class="col-num">Kills</th>
              <th class="col-num">Chests looted</th>
              <th class="col-num">Points</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(entry, idx) in displayTeams" :key="teamRowKey(entry, idx)">
              <td>{{ entry.name }}</td>
              <td class="col-num">{{ entry.kills }}</td>
              <td class="col-num">{{ entry.chestsLooted }}</td>
              <td class="col-num">{{ entry.points }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { getMatch } from "../services/MatchService";
import { checkLast } from "../services/CacheService";

export default {
  name: "Match",
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      match: null,
      loading: true,
      loadError: false,
      notFound: false,
      refreshLast: -1,
      polling: null,
    };
  },
  computed: {
    displayTeams() {
      if (!this.match || !Array.isArray(this.match.teams)) {
        return [];
      }
      const rows = this.match.teams.map((t) => {
        const players = Array.isArray(t.players) ? t.players : [];
        let kills = 0;
        let chestsLooted = 0;
        for (const p of players) {
          kills += Number(p.kills) || 0;
          chestsLooted += Number(p.chestsLooted) || 0;
        }
        return {
          name: t.name,
          points: t.points,
          kills,
          chestsLooted,
        };
      });
      return rows.sort((a, b) => (b.points || 0) - (a.points || 0));
    },
  },
  watch: {
    id() {
      this.fetchMatch();
    },
  },
  methods: {
    teamRowKey(entry, idx) {
      return entry.name != null ? String(entry.name) : `team-${idx}`;
    },
    fetchMatch() {
      this.loading = true;
      this.loadError = false;
      this.notFound = false;
      getMatch(this.id)
        .then((data) => {
          if (data === null) {
            this.match = null;
            this.notFound = true;
          } else {
            this.match = data;
          }
        })
        .catch(() => {
          this.match = null;
          this.loadError = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    pollData() {
      this.polling = setInterval(() => {
        checkLast().then((response) => {
          if (response.last == undefined) {
            return;
          }
          if (this.refreshLast === -1) {
            this.refreshLast = response.last;
          } else if (this.refreshLast !== response.last) {
            this.refreshLast = response.last;
            this.fetchMatch();
          }
        });
      }, 15000);
    },
  },
  mounted() {
    this.fetchMatch();
    this.pollData();
  },
  beforeDestroy() {
    clearInterval(this.polling);
  },
};
</script>

<style scoped>
.match-overlay-root {
  background: transparent;
  padding: 0;
}

.match-overlay-status {
  color: #fff;
  font-weight: 700;
  text-transform: uppercase;
  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.9);
  padding: 0.6rem 1rem;
}

.match-panel {
  background: rgba(21, 25, 37, 0.92);
}

.match-table {
  width: 100%;
  border-collapse: collapse;
  font-family: Poppins, sans-serif;
  letter-spacing: 1.5px;
}

.match-table thead tr {
  background: #e6863c;
}

.match-table th {
  color: #191d28;
  font-weight: 700;
  font-size: 1.8rem;
  text-transform: uppercase;
  padding: 0.5rem 1rem;
  border: none;
}

.match-table tbody tr {
  border-bottom: 1px solid rgba(230, 134, 60, 0.18);
}

.match-table tbody tr:last-child {
  border-bottom: none;
}

.match-table tbody tr:nth-child(odd) {
  background: rgba(230, 134, 60, 0.08);
}

.match-table tbody tr:nth-child(even) {
  background: rgba(21, 25, 37, 0.6);
}

.match-table td {
  color: #fff;
  font-weight: 500;
  font-size: 1.4rem;
  padding: 0.55rem 1rem;
  border: none;
}

.col-num {
  width: 18%;
  text-align: center;
  white-space: nowrap;
}

.match-table thead .col-num {
  text-align: center;
}
</style>
